/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import Enum from './Enum';
//@import Enum (loadtime) // superclass

/**
 * Enumeration of query subject types a user can convert to. This class will be translated to JavaScript
 * @author  alan-tran
 */
export default class ConvertQSType extends Enum{

	/**
	 * Table Type.
	 */
	static  TABLE = ConvertQSType.newLiteral("TABLE");

	/**
	 * View Type.
	 */
	static  VIEW = ConvertQSType.newLiteral("VIEW");

	/**
	 * Shortcut Type.
	 */
	static  SHORTCUT = ConvertQSType.newLiteral("SHORTCUT");

	/**
	 * Alias Type.
	 */
	static  ALIAS = ConvertQSType.newLiteral("ALIAS");



	value() {
		return this.name();
	}
}


// WEBPACK FOOTER //
// ./src/generated/ConvertQSType.js